import ProductCardBadge from "./ProductCardBadge";
import ProductCardBadges from "./ProductCardBadges";
import ProductCardBrand from "./ProductCardBrand";
import ProductCardContent from "./ProductCardContent";
import ProductCardImage from "./ProductCardImage";
import ProductCardLink from "./ProductCardLink";
import ProductCardPrice from "./ProductCardPrice";
import ProductCardRemove from "./ProductCardRemove";
import ProductCardRoot from "./ProductCardRoot";
import ProductCardStockStatus from "./ProductCardStockStatus";
import ProductCardTitle from "./ProductCardTitle";

const composedProductCard = {
  Root: ProductCardRoot,
  Link: ProductCardLink,
  Image: ProductCardImage,
  Content: ProductCardContent,
  Badge: ProductCardBadge,
  Badges: ProductCardBadges,
  Remove: ProductCardRemove,
  Brand: ProductCardBrand,
  Title: ProductCardTitle,
  Price: ProductCardPrice,
  StockStatus: ProductCardStockStatus,
};

export default composedProductCard;
